import {
  controlKeys,
  remediationAuditLogKeys,
  remediationKeys,
} from "../../../../../../../api/queryKeys";

export const resetQueriesAfterAutoRemediation = (queryClient, controlId) => {
  queryClient.resetQueries({
    queryKey: controlKeys.all,
  });
  queryClient.clear({
    queryKey: controlKeys.controlMisconfiguredEntities(controlId),
  });
  queryClient.resetQueries({
    queryKey: remediationKeys.remediation(controlId),
  });
  queryClient.resetQueries({
    queryKey: remediationAuditLogKeys.all,
  });
};
